<ng-container>
  <div class="request-account" [style.display]="requestAccount ? 'block' : 'none'">
    <div class="d-flex" style="flex-direction: column">
      <div class="request-account-heading">
        <a (click)="returnToLogin()" [routerLink]="['/login']" rel="noopenner noreferrer"
          ><i class="material-icons back-icon">keyboard_arrow_left</i>{{ 'requestAccount.back' | cxTranslate }}</a
        >
        <h1>{{ 'requestAccount.requestAccount' | cxTranslate }}</h1>
        <p>{{ 'requestAccount.requestAccountInfo' | cxTranslate }}</p>
      </div>
      <div class="request-form-body" [class.hide-state]="this.hasState === 'false'">
        <app-dynamic-form
          (formGroupEmit)="updateFormGroup($event)"
          (formModelEmit)="updateFormModelDynamic($event)"
          [formGroupId]="'REQUEST_ACCOUNT'"
          [emitOnInit]="true"
          [static]="false"
        ></app-dynamic-form>
      </div>
      <div class="sticky" [ngClass]="getOS()">
        <div class="request-submit">
          <button [disabled]="!formGroup?.valid" (click)="onClickSubmit($event)" class="button primary-btn btn-submit">
            {{ 'requestAccount.requestAccount' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="request-account-success" [style.display]="success ? 'block' : 'none'">
    <h1>{{ 'requestAccount.thankYou' | cxTranslate }}</h1>
    <p>{{ 'requestAccount.representative' | cxTranslate }}</p>
    <div style="display: flex; justify-content: flex-end">
      <a class="button primary-btn" href="https://www.shimano.com/" rel="noopenner noreferrer">{{
        'requestAccount.goTo' | cxTranslate
      }}</a>
    </div>
  </div>
</ng-container>
